import protoRoot from "../proto-root";

const name = "playCommandRpcRequest";

function create({ commandId }) {
  const PlayCommandRpcRequest = protoRoot.lookupType(
    "comm.PlayCommandRpcRequest"
  );

  const request = PlayCommandRpcRequest.create({ commandId });

  return { payload: request, name };
}

export default {
  create,
  name
};

// message PlayCommandRpcRequest {
//     string commandId = 1;
// }
